// // src/components/AppLayout.jsx
// import React from "react";
// import { Box, useMediaQuery } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// import appBgDesktop from "../assets/app-bg-desktop.jpg";
// import appBgMobile from "../assets/app-bg-mobile.jpg";

// export default function AppLayout({ children }) {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         backgroundImage: `url(${isMobile ? appBgMobile : appBgDesktop})`,
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         p: { xs: 2, md: 4 },
//       }}
//     >
//       {children}
//     </Box>
//   );
// }

// import React from 'react';
// import { Box } from '@mui/material';
// import Sidebar from './layout/Sidebar';
// import Navbar from './layout/Navbar';
// import backgroundImage from '../assets/App-bg.jpg';

// const AppLayout = ({ children }) => {
//   return (
//     <Box 
//       sx={{
//         display: 'flex',
//         minHeight: '100vh',
//         backgroundImage: `url(${backgroundImage})`,
//         backgroundSize: 'cover',
//         backgroundRepeat: 'no-repeat',
//         backgroundPosition: 'center',
//         backgroundAttachment: 'fixed', // optional for parallax effect
//       }}
//       >
//       <Sidebar />
//       <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
//         <Navbar />
//         <Box component="main" sx={{ p: 3, flexGrow: 1 }}>
//           {children}
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default AppLayout;

// import React from 'react';
// import { Box } from '@mui/material';
// import Sidebar from './layout/Sidebar';
// import Navbar from './layout/Navbar';
// import backgroundImage from '../assets/App-bg.jpg';

// const AppLayout = ({ children }) => {
//   return (
//     <Box
//       sx={{
//         position: 'relative',
//         display: 'flex',
//         minHeight: '100vh',
//         width: '100%',
//         overflow: 'hidden',
//       }}
//     >
//       {/* ✅ Background layer */}
//       <Box
//         sx={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           width: '100%',
//           height: '100%',
//           backgroundImage: `url(${backgroundImage})`,
//           backgroundSize: 'cover',
//           backgroundRepeat: 'no-repeat',
//           backgroundPosition: 'center',
//           zIndex: 2, // behind everything
//         }}
//       />

//       {/* ✅ Foreground layout */}
//       <Box
//         sx={{
//           position: 'relative',
//           display: 'flex',
//           flexGrow: 1,
//           zIndex: 1, // above background
//         }}
//       >
//         <Sidebar />
//         <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
//           <Navbar />
//           <Box
//             component="main"
//             sx={{
//               p: 3,
//               flexGrow: 1,
//               minHeight: '100vh',
//             }}
//           >
//             {children}
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default AppLayout;

// import React, { useState } from 'react';
// import { Box, Toolbar, useMediaQuery } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
// import Sidebar from './layout/Sidebar';
// import Navbar from './layout/Navbar';
// import backgroundImage from '../assets/App-bg.jpg';

// export default function AppLayout({ children }) {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const [sidebarOpen, setSidebarOpen] = useState(!isMobile);

//   const toggleSidebar = () => setSidebarOpen((s) => !s);

//   return (
//     <Box sx={{ minHeight: '100vh', width: '100%', position: 'relative', bgcolor: 'transparent' }}>
//       {/* Background layer (fixed, behind everything) */}
//       <Box
//         sx={{
//           position: 'fixed',
//           inset: 0,
//           backgroundImage: `url(${backgroundImage})`,
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           backgroundRepeat: 'no-repeat',
//           zIndex: 0,
//         }}
//       />

//       {/* Foreground layout */}
//       <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', minHeight: '100vh' }}>
//         <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

//         <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
//           <Navbar toggleSidebar={toggleSidebar} />

//           {/* toolbar spacer to push content under fixed AppBar */}
//           <Toolbar />

//           <Box
//             component="main"
//             sx={{
//               p: { xs: 2, md: 4 },
//               flexGrow: 1,
//               // use a translucent background to let the bg image show through
//               background: 'linear-gradient(rgba(0,0,0,0.25), rgba(0,0,0,0.18))',
//               backdropFilter: 'blur(2px)',
//               minHeight: 'calc(100vh - 64px)',
//               boxSizing: 'border-box',
//             }}
//           >
//             {children}
//           </Box>
//         </Box>
//       </Box>
//     </Box>
//   );
// }

import React, { useState, useMemo } from 'react';
import { Box, Toolbar, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Sidebar from './layout/Sidebar';
import Navbar from './layout/Navbar';
import backgroundImage from '../assets/App-bg.jpg';

export default function AppLayout({ children }) {
  const theme = useTheme();

  // media query hooks at top level
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));

  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const toggleSidebar = () => setSidebarOpen((s) => !s);
  const toggleCollapse = () => setSidebarCollapsed((s) => !s);

  const drawerWidth = useMemo(() => {
    if (isMobile) return 0;
    if (sidebarCollapsed) return 72; // collapsed width (icons only)
    if (isTablet) return 180;
    return 220;
  }, [isMobile, isTablet, sidebarCollapsed]);

  return (
    <Box sx={{ minHeight: '100vh', width: '100%', position: 'relative', bgcolor: 'transparent' }}>
      {/* Fixed background layer */}
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          zIndex: 0,
        }}
      />

      {/* Foreground layout */}
      <Box sx={{ position: 'relative', zIndex: 1, display: 'flex', minHeight: '100vh' }}>
        <Sidebar
          isOpen={sidebarOpen}
          collapsed={sidebarCollapsed}
          toggleSidebar={toggleSidebar}
          toggleCollapse={toggleCollapse}
          drawerWidth={drawerWidth}
        />

        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            ml: { sm: `${drawerWidth}px` },
            transition: (t) =>
              t.transitions.create(['margin', 'width'], {
                easing: t.transitions.easing.sharp,
                duration: t.transitions.duration.standard,
              }),
          }}
        >
          <Navbar toggleSidebar={toggleSidebar} />
          <Toolbar />
          <Box
            component="main"
            sx={{
              p: { xs: 2, md: 4 , },
              flexGrow: 1,
              background: 'linear-gradient(rgba(0,0,0,0.25), rgba(0,0,0,0.18))',
              backdropFilter: 'blur(2px)',
              minHeight: 'calc(100vh - 64px)',
              boxSizing: 'border-box',
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
